import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";
import defaultProfile from "@/game_profiles/default";
import { commonMenuItems } from "@/game_profiles/common";

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "branch" } },
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "broadcastMessages" } },
  { component: "ConfSection", props: { name: "extended" } },
  { component: "ConfSection", props: { name: "pvp" } },
  { component: "ConfSection", props: { name: "storm" } },
];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  readOnlyMode: true,
});
